module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-10-1f47e1b2.png";